const CloseIcon = ({ className, isSelected = false }) => {
  const fillColor = isSelected ? 'var(--forbrand-primary)' : 'var(--forbrand-secondary)'

  return (
    <div
      className={`${className} flex items-center justify-center w-[24px] h-[24px]`}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 6L6 18M6 6L18 18"
          stroke={fillColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}

export default CloseIcon
